var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.135 16.966L19.34 1.76M19.34 16.966L4.136 1.76",
    stroke: "#1B264F",
    strokeWidth: 2.4,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "media/images/closeIconBlack-6a13ddcd.svg";
export { SvgCloseIconBlack as ReactComponent };